export default "__VITE_ASSET__CyUfIvKF__"